<template>
  <div class="tab-box">
    <a-tabs type="editable-card" v-model="activeKey" defaultActiveKey="/" hide-add :tabBarStyle="{backgroundColor:'#fff',color:'#333',borderBottom:'none'}" @tabClick="tabChange" @edit="editHandle">
      <a-tab-pane v-for="pane in openTab" :key="pane.path" :tab="pane.meta.title" :closable="showClose(pane)"></a-tab-pane>
      <a-dropdown slot="tabBarExtraContent" style="margin-left:10px;">
        <a class="ant-dropdown-link" @click="e => e.preventDefault()">
          <!-- 更多 -->
          <a-icon type="down" style="fontSize:20px;"/>
        </a>
        <a-menu slot="overlay" @click="dropdownClickHandle">
          
          <a-menu-item key="closeCurrent">
            <a-button type="link">关闭当前标签页</a-button>
          </a-menu-item>
          <a-menu-item key="closeOther">
            <a-button type="link">关闭其它标签页</a-button>
          </a-menu-item>
          <a-menu-item key="closeAll">
            <a-button type="link">关闭全部标签页</a-button>
          </a-menu-item>

        </a-menu>
      </a-dropdown>
    </a-tabs>
  </div>
</template>
<script>
import Tab from "./Tab.js";
export default Tab;
</script>
<style lang="less" scope>
@import "Tab";
</style>